var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex-row align-content-start",
      attrs: { id: "logged-in-banner" },
    },
    [
      _c("div", { staticClass: "flex-grow-1" }, [
        _setup.props.user && _setup.props.user.slug
          ? _c(
              "div",
              {
                staticClass: "d-flex align-items-center align-content-start",
                attrs: { id: "greeting" },
              },
              [
                _c(
                  _setup.CiRouterLink,
                  {
                    attrs: {
                      to: {
                        name: _vm.$routes.USERS_SHOW,
                        params: { slug: _setup.props.user.slug },
                      },
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _setup.emit("tracking-click", {
                          targetName: "UserProfile",
                          targetId: _setup.props.user.slug,
                          sourceName: "Header",
                        })
                      },
                    },
                  },
                  [
                    _c(_setup.CiUserAvatar, {
                      staticClass:
                        "m-3 m-xl-4 d-none d-md-block cursor-pointer",
                      attrs: {
                        size: _setup.avatarSize,
                        src: _setup.props.user.avatar,
                        username: _setup.props.user.firstname,
                        icon: !_setup.props.user.avatar && "mdi-plus",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "ml-3" }, [
                  _c("h2", {
                    class: `text-center text-md-left ${
                      _setup.viewportService.check(["xxl", "xl"]) ? "h1" : ""
                    }`,
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(_setup.greetingPath, {
                          firstname: _setup.props.user.firstname,
                        })
                      ),
                    },
                  }),
                ]),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          {
            staticClass:
              "partner-teaser-banner d-flex flex-row align-items-center py-2",
          },
          [
            _setup.props.partner
              ? [
                  _c(_setup.CiCompanyTile, {
                    attrs: {
                      company: _setup.props.partner,
                      context: "start-page",
                      "padding-class": "p-0",
                    },
                    on: { "tracking-click": _setup.propagateTrackClick },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "partner-teaser-banner-text d-flex flex-row align-items-center px-3 py-1",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "ui.components.start.logged_in_banner.partner_teaser"
                        )
                      ),
                    },
                  }),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }